// Function to close all modals
 function closeAllModals() {
    var modals = document.querySelectorAll('.mythbusters-modal');
    modals.forEach(function(modal) {
      modal.classList.remove('active');
      document.body.classList.remove('mythbusters-open');
    });
  }

  // Function to remove active class from all mythbuster buttons
  function removeActiveFromAllMythbusters() {
    var mythbusters = document.querySelectorAll('.mythbusters-card');
    mythbusters.forEach(function(mythbuster) {
      mythbuster.classList.remove('active');
    });
  }

  // Get all elements with data-mythbusters attribute
  var mythBusterButtons = document.querySelectorAll('.mythbusters-card');

   // Attach click event listener to each element
   mythBusterButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var modalId = button.getAttribute('data-mythbusters');
        var modal = document.getElementById(modalId);
  
        // Close all other modals and open the clicked modal
        closeAllModals();
        modal.classList.add('active');
        document.body.classList.add('mythbusters-open');
        // Remove active class from all mythbuster buttons and add to the clicked one
        removeActiveFromAllMythbusters();
        button.classList.add('active');
      });
    });

  // Close modal when close button is clicked
  var closeButtons = document.querySelectorAll('.myth-close');
  closeButtons.forEach(function(closeButton) {
    closeButton.addEventListener('click', function() {
      var modal = closeButton.parentElement.parentElement;
      modal.classList.remove('active');
      document.body.classList.remove('mythbusters-open');
      // Remove active class from all mythbuster buttons when modal is closed
      removeActiveFromAllMythbusters();
    });
  });